import { userApi } from "@/user/api";

const g = (u, params) => userApi.get(u, params ? { params } : undefined).then((r) => r.data);

export const ceoApi = {
    overview: () => g("/ceo/overview"),
    departments: () => g("/ceo/departments"),
    feed: (limit = 30) => g("/ceo/feed", { limit }),
    submissions: (params = {}) => g("/ceo/submissions", params),
    submission: (id) => g(`/ceo/submissions/${id}`),
    documents: (params = {}) => g("/ceo/documents", params),
    attachment: (id) => g(`/ceo/attachments/${id}`),
    tasksOverview: () => g("/ceo/tasks/overview"),
    meetings: () => g("/ceo/meetings"),
    notifications: () => g("/ceo/notifications"),
    health: () => g("/ceo/health"),
    moneyMeter: () => g("/ceo/money-meter"),
    moneyMeterSimulate: (deltas) => userApi.post("/ceo/money-meter/simulate", { deltas }).then((r) => r.data),
    department: (dept) => g(`/ceo/department/${dept}`),
    employee: (id) => g(`/ceo/employee/${id}`),
    search: (q) => g("/ceo/search", { q }),
    // Decision / Snippet cards
    cards: (params = {}) => g("/ceo/cards", params),
    card: (id) => g(`/ceo/cards/${id}`),
    cardsSummary: () => g("/ceo/cards/summary"),
    generateCards: () => userApi.post("/ceo/cards/generate").then((r) => r.data),
    cardAction: (id, action, note = "") => userApi.post(`/ceo/cards/${id}/action`, { action, note }).then((r) => r.data),
    cardsLibrary: () => g("/ceo/cards-library"),
    // Business Scan AI (Gemini Vision)
    scan: {
        upload: (file, conversationId = "") => {
            const fd = new FormData();
            fd.append("file", file);
            if (conversationId) fd.append("conversation_id", conversationId);
            return userApi.post("/ceo/scan", fd, {
                headers: { "Content-Type": "multipart/form-data" },
                timeout: 120000,
            }).then((r) => r.data);
        },
        list: (limit = 50) => g("/ceo/scans", { limit }),
        get: (id) => g(`/ceo/scans/${id}`),
        del: (id) => userApi.delete(`/ceo/scans/${id}`).then((r) => r.data),
    },
    // Conversational command center (Phase 5)
    chat: {
        list: () => g("/ceo/chat/conversations"),
        create: () => userApi.post("/ceo/chat/conversations").then((r) => r.data),
        get: (id) => g(`/ceo/chat/conversations/${id}`),
        send: (id, text, attachments = []) => userApi.post(`/ceo/chat/conversations/${id}/message`, { text, attachments }).then((r) => r.data),
        patch: (id, body) => userApi.patch(`/ceo/chat/conversations/${id}`, body).then((r) => r.data),
        del: (id) => userApi.delete(`/ceo/chat/conversations/${id}`).then((r) => r.data),
    },
};
